<template>
  <div>
    <Head title="Kontakt" />
    <div class="flex flex-wrap lg:justify-between max-w-6xl">
      <div class="w-full lg:w-1/2 xl:w-6/12 sm:px-4">
        <div class="p-2 sm:p-6">
          <h1 class="text-2xl sm:text-5xl font-extrabold tracking-tight text-left">Kontaktieren Sie uns</h1>
          <p class="text-normal text-lg sm:text-2xl font-medium mt-2">Nutzen Sie dazu unser Kontaktformular oder eine der folgenden Optionen:</p>

          <a href="https://goo.gl/maps/3rZkuqN4iGL7SReL6" target="_blank" class="flex items-center mt-8">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <div class="ml-4 text-md tracking-wide font-semibold w-40">Bergstraße 16<br />03096 Guhrow</div>
          </a>

          <a href="tel:+49 174 69 95 735" class="flex items-center mt-4">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <div class="ml-4 text-md tracking-wide font-semibold w-56">+49 174 69 95 735 (12-19 Uhr)</div>
          </a>

          <a href="mailto:raukamp-apartments@gmx.de" class="flex items-center mt-2">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <div class="ml-4 text-md tracking-wide font-semibold w-64">raukamp-apartments@gmx.de</div>
          </a>
        </div>
      </div>
      <div class="w-full lg:w-1/2 xl:w-6/12 sm:px-4 pt-10">
        <div class="bg-white relative rounded-lg p-3 sm:p-8 md:p-12 shadow-lg">
          <form @submit.prevent="store">
            <flash-messages />
            <div class="mb-4">
              <text-input v-model="form.name" :error="form.errors.name" class="w-full rounded py-3 px-[14px] text-body-color text-base outline-none focus-visible:shadow-none focus:border-primary" label="Name" />
            </div>
            <div class="mb-4">
              <text-input v-model="form.email" :error="form.errors.email" class="w-full rounded py-3 px-[14px] text-body-color text-base outline-none focus-visible:shadow-none focus:border-primary" label="E-Mail Adresse *" />
            </div>
            <div class="mb-4">
              <text-input v-model="form.phone" :error="form.errors.phone" class="w-full rounded py-3 px-[14px] text-body-color text-base outline-none focus-visible:shadow-none focus:border-primary" label="Telefonnummer *" />
            </div>
            <div class="mb-4">
              <textarea-input v-model="form.message" :error="form.errors.message" class="w-full rounded py-3 px-[14px] text-body-color text-base resize-none outline-none focus-visible:shadow-none focus:border-primary" rows="6" label="Nachricht" />
            </div>
            <div class="p-4">
              <loading-button :loading="form.processing" class="w-full text-white bg-secondary rounded p-3 transition hover:bg-opacity-90" type="submit">Absenden</loading-button>
            </div>
            <div class="text-xs">* Es muss mind. eine E-Mail Adresse oder Telefonnummer angeben werden.</div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    LoadingButton,
    FlashMessages,
    Head,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        message: null,
      }),
    }
  },
  methods: {
    store() {
      let url = route('frontend.contact.post')
      this.form.post(url, {
        onSuccess: () => {
          if (parseInt(this.$page.props.response_code) == 419) {
            this.$inertia.reload()
          } else {
            this.form.reset()
          }
        },
      })
    },
  },
}
</script>
